// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Location: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<path d="M11.9,23.85l-5.81-7.62c-1.53-2-3.11-4.08-3.11-7.08c0-4.96,4.04-9,9.02-9c4.97,0,9.02,4.04,9.02,9
	c0,2.47-1.17,4.45-2.2,5.9l0,0c-0.75,1.07-6.13,7.81-6.36,8.09L11.9,23.85z M12,1.55c-4.2,0-7.62,3.41-7.62,7.6
	c0,2.54,1.37,4.33,2.82,6.23l4.72,6.19c1.43-1.8,5.16-6.49,5.75-7.33l0,0c1.36-1.93,1.94-3.45,1.94-5.1
	C19.62,4.96,16.2,1.55,12,1.55z"/>
<path d="M12,13.43c-2.49,0-4.52-2.02-4.52-4.5s2.03-4.5,4.52-4.5s4.52,2.02,4.52,4.5S14.49,13.43,12,13.43z M12,5.83
	c-1.72,0-3.12,1.39-3.12,3.1s1.4,3.1,3.12,3.1c1.72,0,3.12-1.39,3.12-3.1S13.72,5.83,12,5.83z"/>
</svg>;
};

export default React.memo(Location);
